import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/quotations-management/components/QuotationsManagementContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Sidebar.tsx");
